export default __webpack_public_path__ + "static/media/02.878b1439.jpg";